// extracted by css-extract-rspack-plugin
export default {"rantion_loading":"erp-rantion_loading_en42O","page404":"erp-page404_M1ubr","subtitle":"erp-subtitle_QbQml"};